/**
 * Created by razial on 2026-05-22.
 */

const RewardedPromoCompletedWindow = Prefab.createWindow("rewarded_promo_window", "rewardedpromocompletedwindow_prefab_json", {
    bundles: (promotion) => (["crosspromo", promotion.getBundleName()])
});
